/**
 * Home screen chrome: greetings, section titles, status chips, and small
 * labels. Clinical and educational copy lives in content.ts; the screen
 * reuses it from there instead of duplicating it here.
 */
export const home = {
  greeting: 'Hi there!',
  greetingWithName: (name: string) => `Hi, ${name}!`,

  prenatal: {
    checklistTitle: 'Getting ready',
    dueDateLabel: (date: string) => `Due date: ${date}`,
    noDueDate: 'Your baby is on the way.',
  },

  birthSheet: {
    when: 'When was baby born?',
    nickname: 'Baby nickname (optional)',
    nicknameHint: 'A nickname is all this app needs. No legal name required.',
    weight: 'Birth weight (optional)',
    lb: 'lb',
    oz: 'oz',
    grams: 'grams',
  },

  visits: {
    title: 'Your visit plan',
    status: {
      upcoming: 'Upcoming',
      due: 'Time to book',
      scheduled: 'Booked',
      past: 'Past',
    },
  },

  checkup: {
    inDays: (days: number) =>
      days === 0 ? 'That is today' : days === 1 ? 'That is tomorrow' : `In ${days} days`,
  },

  today: {
    title: 'Today at a glance',
    feeds: 'Feedings',
    wetDiapers: 'Wet diapers',
    dirtyDiapers: 'Stools',
    ofMin: (n: number, min: number) => `${n} of ${min}`,
    lastFeed: (ago: string) => `Last feeding: ${ago}`,
    empty: 'Nothing logged yet today. Anything you add in the Track tab shows up here.',
  },

  nudge: {
    sinceLastFeed:
      'It has been a few hours since the last logged feeding. If baby is showing hunger cues, this may be a good time.',
    noFeedsYet: 'Whenever baby eats, log it in Track and your day will take shape here.',
    action: 'Go to Track',
  },

  partner: {
    guideLink: 'See all tips in the Guide',
  },
};
